/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { FilterMetadata } from 'primeng/api/filtermetadata';
import { FilterMatchMode } from 'primeng/api';
import { DateUtilsService } from '@irian-ro/date-utils';
import { format } from 'date-fns';
import { PackageStatusType } from './package-status-type';

export const EXCLUDED_DEFAULT_FILTER_STATUSES: string[] = [
  PackageStatusType.REQUESTED,
  PackageStatusType.REQUEST_REJECTED,
  PackageStatusType.CANCELLED,
];

export class PackageTrackingFilters {
  packageId?: FilterMetadata = {
    value: '',
    matchMode: FilterMatchMode.CONTAINS,
  };
  lastModifiedAt?: FilterMetadata = {
    value: format(DateUtilsService.dateObjectWithDaysOffset(10), 'yyyy-MM-dd'),
    matchMode: FilterMatchMode.GREATER_THAN,
  };

  deliveryDate?: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.LESS_THAN,
  };
  shipmentSeries?: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.CONTAINS,
  };
  deliveryCity?: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.CONTAINS,
  };
  pickupCity?: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.CONTAINS,
  };
  pickupNamedLocationUuid?: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.IN,
  };
  deliveryNamedLocationUuid?: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.IN,
  };
  pickupDate?: FilterMetadata = {
    value: null,
    matchMode: FilterMatchMode.GREATER_THAN,
  };
  packageStatusType?: FilterMetadata = {
    value: Object.values(PackageStatusType).filter((s) => !EXCLUDED_DEFAULT_FILTER_STATUSES.includes(s)),
    matchMode: FilterMatchMode.IN,
  };
}
